export const REQUESTOR_ID = 'requestor'

export const ASSESSMENT_OWNER_ID = 'businessOwner'
